import React from "react";
interface props {
  right?: boolean;
}
const SvgArrow: React.FC<props> = ({ right }) => {
  return (
    <svg
      style={right ? { transform: " rotate(180deg)" } : {}}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23904_30510)">
        <path
          d="M11.9883 2.39415C11.8324 2.3988 11.6845 2.46394 11.5758 2.57579L5.57581 8.57579C5.46333 8.68832 5.40015 8.84091 5.40015 9.00001C5.40015 9.15911 5.46333 9.3117 5.57581 9.42423L11.5758 15.4242C11.6311 15.4818 11.6973 15.5278 11.7706 15.5595C11.8439 15.5911 11.9227 15.6079 12.0026 15.6087C12.0824 15.6095 12.1616 15.5944 12.2355 15.5642C12.3094 15.534 12.3765 15.4894 12.433 15.433C12.4894 15.3765 12.534 15.3094 12.5642 15.2355C12.5944 15.1615 12.6095 15.0824 12.6087 15.0025C12.6079 14.9227 12.5912 14.8439 12.5595 14.7706C12.5278 14.6973 12.4818 14.6311 12.4242 14.5758L6.84847 9.00001L12.4242 3.42423C12.511 3.33995 12.5702 3.23145 12.5941 3.11294C12.6181 2.99442 12.6057 2.87143 12.5586 2.76008C12.5115 2.64873 12.4318 2.55421 12.3301 2.48892C12.2283 2.42362 12.1092 2.39059 11.9883 2.39415Z"
          className="fill-primary"
        />
      </g>
      <defs>
        <clipPath id="clip0_23904_30510">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgArrow;
